import { render, staticRenderFns } from "./3Ddemo.vue?vue&type=template&id=2dbde9df&scoped=true&"
import script from "./3Ddemo.vue?vue&type=script&lang=js&"
export * from "./3Ddemo.vue?vue&type=script&lang=js&"
import style0 from "./3Ddemo.vue?vue&type=style&index=0&id=2dbde9df&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dbde9df",
  null
  
)

export default component.exports